/* global FIREBASE_API_KEY */
/* global FIREBASE_AUTH_DOMAIN */
/* global FIREBASE_PROJECT_ID */
/* global FIREBASE_STORAGE_BUCKET */
/* global FIREBASE_MESSAGING_SENDER_ID */
/* global FIREBASE_APP_ID */
/* global FIREBASE_MEASUREMENT_ID */

import { initializeApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: FIREBASE_API_KEY,
  authDomain: FIREBASE_AUTH_DOMAIN,
  projectId: FIREBASE_PROJECT_ID,
  storageBucket: FIREBASE_STORAGE_BUCKET,
  messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
  appId: FIREBASE_APP_ID,
  measurementId: FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const functions = getFunctions(app);
// NOTE: Messaging is intentionally NOT initialized here. Calling getMessaging() eagerly
// at module load registers `navigator.serviceWorker.addEventListener` inside Firebase's
// MessagingService, which throws `undefined is not an object` in browsers without a Service
// Worker (private-mode Safari/Firefox, some webviews) and crashed the whole app on first load.
// Push notifications use the guarded instance from `firebase-push.ts` (null when unsupported).
export const processMenu = httpsCallable(functions, 'processMenu');
export const processMenuV2 = httpsCallable(functions, 'processMenuV2', {
  timeout: 300000, // 5 minutos = 300,000ms (vs 60s default)
}); // NUEVO: Para MenuUploaderV2 con timeout extendido
export const processMenuV3 = httpsCallable(functions, 'processMenuV3', {
  timeout: 300000, // 5 minutos para Claude (similar a V2)
}); // V3: Usa Anthropic Claude en vez de Gemini (más estable)
export const processMenuV4 = httpsCallable(functions, 'processMenuV4', {
  timeout: 900000, // 15 minutos: prompt V4 con max_tokens 32k-64k puede tardar
}); // V4: Claude Haiku 4.5 + prompt V4 + validador con retries (schemaVersion 4.0)
export const getMenuJobResult = httpsCallable(functions, 'getMenuJobResult', {
  timeout: 30000,
}); // Recovery: consulta el resultado persistido de un job V4 por jobId cuando la conexión del callable murió
export default app;
